import {
  ToastContainer,
  toast,
  ToastOptions,
  ToastPosition as ReactToastifyPosition,
  Slide,
  Zoom,
  Flip,
  Bounce,
} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const Toaster = () => {
  return (
    <ToastContainer
      position="top-center"
      autoClose={4000}
      newestOnTop={true}
      hideProgressBar={false}
      closeOnClick={true}
      pauseOnHover={true}
      draggable={true}
      draggablePercent={60}
      limit={3}
      rtl={false}
      transition={Slide}
      style={{ zIndex: 9999 }}
    />
  );
};

export type ToastType = "success" | "error" | "info" | "warning";
export type ToastPositionType =
  | "top-right"
  | "top-center"
  | "top-left"
  | "bottom-right"
  | "bottom-center"
  | "bottom-left";

export const showToast = (
  message: string,
  type: ToastType,
  options?: ToastOptions & {
    position?: ToastPositionType;
    transition?: typeof Slide | typeof Zoom | typeof Flip | typeof Bounce;
  }
) => {
  const config: ToastOptions = {
    ...options,
    theme: "colored",
    position: (options?.position || "top-center") as ReactToastifyPosition,
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 60,
    transition: options?.transition || Slide,
  };

  switch (type) {
    case "success":
      toast.success(message, config);
      break;
    case "error":
      toast.error(message, config);
      break;
    case "info":
      toast.info(message, config);
      break;
    case "warning":
      toast.warn(message, config);
      break;
    default:
      break;
  }
};
